import React, { useEffect } from 'react'
import { DeleteFilled, EditFilled, FilterOutlined, PlusCircleFilled, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, Input, Modal, Row, Select, Space, Table, Tag, Typography } from 'antd';
import { Pagination } from "@mui/material";
import Message from '../../Components/common/Message';
import AuthService from '../../Components/auth/AuthService';
import { encodeId } from '../../Components/common/CommonFun';
import { useLoadingDispatch, showLoading, hideLoading } from "../../context/loadingContext";
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { locationCategories} from '../../Components/common/Constants';
import { useSelector } from 'react-redux';
import { showMessage } from '../../Components/Utils/message';
import { EXPIRATION_TIME } from '../../Components/common/Constants';

const AntTable = styled('div')`
  .ant-table-tbody > tr > td {
    border-bottom: '1px solid #b7b9bd';
  }
`;
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;

const Auth = new AuthService();

const LocationList = () => {
  const { Text } = Typography;
  const { locations, aisles, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);

  const { Option } = Select;
  const navigate = useNavigate()
  const layoutDispatch = useLoadingDispatch()
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");
  
  const [filters, setFilters] = React.useState(() => {
    const existing = localStorage.getItem('LocationsFilters');
    const parsed = existing ? JSON.parse(existing) : {};
    const currentTime = new Date().getTime();

    const defaultFilters = {
      selected_aisle: null,
      selected_location: '',
      page: 1
    };

    if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
      return { ...defaultFilters, ...parsed };
    }
    localStorage.removeItem('LocationsFilters');
    return defaultFilters;
  });

  const updateFilters = (newValues) => {
    const existingString = localStorage.getItem('LocationsFilters');
    const existing = existingString ? JSON.parse(existingString) : {};

    Object.assign(existing, newValues);
    existing.timestamp = new Date().getTime();

    localStorage.setItem('LocationsFilters', JSON.stringify(existing));
  };

  const [totalPages, setTotalPages] = React.useState(0);
  const [limit] = React.useState(50);
  const [totalCount, setTotalCount] = React.useState(null);

  const [allLocations, setAllLocations] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

   const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));

  const handleRowClick = (id) => {
        const hasedID = encodeId(id)

    navigate(`/locations/${hasedID}`)
  };

  const locationColumns = [
  
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    // {
    //   title: 'Title',
    //   dataIndex: 'title',
    //   key: 'title',
    // },
    {
      title: 'Aisle',
      dataIndex: 'aisle',
      key: 'aisle',
    },
    {
      title: 'Type',
      render: (record) => {
        return record?.type ? locationCategories.find(obj => obj.id == record.type).title : '';
      }
    },
    {
      title: 'Pallet Capacity',
      render: (record) => {
        return (
          
          <Tag color='blue' style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.pallet_capacity.toLocaleString()} </Tag>
        )
      }
    },
    {
      title: 'Used Capacity',
      
      render: (record) => {
        const palletCap = Number(record?.pallet_capacity ?? 0);
       const remainingCap = Number(record?.remaining_capacity ?? 0);

      let used = palletCap - remainingCap;
      if (isNaN(used)) used = 0;
      const percent = palletCap > 0 ? ((used / palletCap) * 100).toFixed(2) : 0;
        return (
          // <span style={{color: 'red', fontWeight: 'bold'}}>{used.toFixed(2)} ({percent}%)</span>
           <>
        <span style={{ color: 'red', fontWeight: 'bold' }}>
          {used.toFixed(2)}
        </span>{' '}
        <span 
        >
          ({percent}%)
        </span>
      </>
        )
      }
    },
    {
      title: 'Remaining Capacity',
      render: (record) => {
        const palletCap = Number(record?.pallet_capacity ?? 0);
        const remainingCap = Number(record?.remaining_capacity ?? 0);
        const percent = palletCap > 0 ? ((remainingCap / palletCap) * 100).toFixed(2) : 0;
        return (
          // <span style={{color: 'green', fontWeight: 'bold'}}>{remainingCap.toFixed(2)} ({percent}%)</span>
          <>
        <span style={{ color: 'green', fontWeight: 'bold' }}>
          {remainingCap.toFixed(2)}
        </span>{' '}
        <span 
        >
          ({percent}%)
        </span>
      </>
        )
      }
    },
    {
      title: 'Width (CMs)',
      render: (record) => {
        return (
          <>{record?.width.toLocaleString()}</>
        )
      }
    },
    {
      title: 'Height (CMs)',
      render: (record) => {
        return (
          <>{record?.height.toLocaleString()}</>
        )
      }
    },
    {
      title: 'Is Transit',
      render: (record) => {
        console.log('record', record)
        return record.is_transit == 1 ? 'Yes' : 'No';
      },
      
    },
    
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        // if (record?.DEFAULT_QUARANTINE) return null;
        return (
          <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center'}} onClick={(e) => e.stopPropagation()}>
            <EditFilled  onClick={() => handleRowClick(record.id)}  style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#001529"}} />
            {canAccess && (
              <DeleteFilled style={
                  {
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Location',
                    centered: true,
                    content: `Are you sure you want to delete this location?`,
                    onOk:()=> deleteLocation(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large"  },
                    cancelButtonProps: { size: "large" },
                  });
                }} 
                />
            )}
            
          </div>
        );
      },
    },
  ];

  const deleteLocation = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/location/location`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getAllLocations();
        showMessage('success',res?.message);
      } else {
        showMessage('error',res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error',err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };
  

  const getAllLocations = async (search) => {
    showLoading(layoutDispatch)
     const payload = {
      limit: limit,
      page: search ? 1 : filters.page,
      searchText: (filters?.selected_location || '').trim(),
    };
 
    if (filters?.selected_aisle) {
      payload.aisle_id = filters.selected_aisle;
    }
    try {
      const res = await Auth.post(`/location/locations`, payload);
      if(res.ack) {
        setAllLocations(res.locations)
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res?.total_count);
      }  else {
        showMessage('error',res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage('error',"Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
    updateFilters({ page: value });
  }; 

  useEffect(()=> {
    getAllLocations()
   },[filters.page, filters.selected_aisle]);


  return (
    <DataSheet>

    <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Locations</>}
            style={{ marginBottom: '10px' }}
            extra={
              <>
        {canAccess && <PlusCircleFilled style={{ fontSize: "30px", color:"#006cb8"}}  onClick={()=> navigate('/locations/new')} />}

              </>
            }
          >
            <Row gutter={[6, 1]}>
              <Col xs={24} md={12} lg={6} xl={6}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Aisle</label>
                <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={filters?.selected_aisle}
              placeholder="Aisle"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                setFilters({ ...filters, selected_aisle: value, page: 1 });
                updateFilters({ selected_aisle: value, page: 1 });
              }}
            >
              {aisles?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item?.title}
                </Option>
              ))}
            </Select>
              </Col>
              <Col xs={24} md={12} lg={6} xl={5}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Location</label>
                <Input
            value={filters?.selected_location}
            onChange={(e) => {
              const value = e.target.value;
              setFilters({ ...filters, selected_location: value, page: 1 });
              updateFilters({ selected_location: value, page: 1 });
            }}
            placeholder='Search Location'
            style={{ width: "100%" }}
          />
              </Col>
              <Col xs={24} md={12} lg={4} xl={4}>
                <Space style={{ width: '100%', marginTop: '25px' }}>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={()=> getAllLocations(true)}
                  >
                    Search
                  </Button>
                </Space>
              </Col>
            </Row>
    </Card>
    
    <AntTable >
      <Table
          dataSource={allLocations}
          columns={locationColumns}
          // style={{ overflowX: "auto" }}
          scroll={{ x: 'max-content'}}
          pagination={false}
          loading={isLoading}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          footer={() => {
            const startRecord = (filters.page - 1) * limit + 1;
            const endRecord = Math.min(filters.page * limit, allLocations?.length ? totalCount : 0); 
            return `Showing ${startRecord}-${endRecord} of ${allLocations?.length ? totalCount : "0"} Records`;
          }}
        />
      </AntTable>
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={filters.page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      <Message type={type} msg={loadMessage} />
    </DataSheet>
  )
}

export default LocationList;
